<template>
  <a-button
    style="padding-left: 1px; width: 100%"
    type="link"
    @click="column.cb(record, text)"
    :title="column.content ? column.content(record, text) : text"
  >
    <span
      v-if="column.content"
      style="
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 100%;
        user-select: text;
        text-align: left;
      "
    >
      {{ column.content(record, text) }}
    </span>
    <span
      v-else
      style="
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 100%;
        user-select: text;
        text-align: left;
      "
    >
      {{ text }}
    </span>
  </a-button>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
export default defineComponent({
  name: 'Cell_click',
  props: {
    column: {
      type: Object,
      required: true,
      default: () => {},
    },
    index: {
      type: Number,
      required: true,
    },
    text: {
      type: [String, Number],
      required: true,
    },
    record: {
      type: Object,
      required: true,
      default: () => {},
    },
    pageSize: {
      type: Number,
      required: true,
      default: () => 20,
    },
    current: {
      type: Number,
      required: true,
      default: () => 1,
    },
  },
});
</script>
